import { render } from "./InfoButton.vue?vue&type=template&id=c0305548"
import script from "./InfoButton.vue?vue&type=script&lang=js"
export * from "./InfoButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__